import { artistsSortOptions, genderFilterOptions } from "../../explore-pages/artists-page/utils";
import {
  CollectorsPageActionTypes,
  CollectorsSearchActions,
  IArtistsPageInitialState,
} from "../types/collectorsSearchActions";

export const collectorsSearchInitialState: IArtistsPageInitialState = {
  artists: [],
  offset: 0,
  sortValue: artistsSortOptions[0],
  filterQueryParams: {},
  originsOfInspiration: [],
  filterResults: [],
  gender: genderFilterOptions[0],
  location: null,
  radius: 10,
};

export const collectorsSearchReducer = (
  state = collectorsSearchInitialState,
  action: CollectorsSearchActions,
): IArtistsPageInitialState => {
  switch (action.type) {
    case CollectorsPageActionTypes.SET_ARTISTS_COLLECTORS:
      return {
        ...state,
        artists: [...action.payload],
      };
    case CollectorsPageActionTypes.SET_OFFSET_COLLECTORS:
      return {
        ...state,
        offset: action.payload,
      };
    case CollectorsPageActionTypes.SET_FILTER_QUERY_PARAMS_COLLECTORS:
      return {
        ...state,
        filterQueryParams: action.payload,
      };
    case CollectorsPageActionTypes.SET_SORT_VALUE_COLLECTORS:
      return {
        ...state,
        sortValue: action.payload,
      };
    case CollectorsPageActionTypes.SET_FILTER_RESULTS_COLLECTORS:
      return {
        ...state,
        filterResults: action.payload,
      };
    case CollectorsPageActionTypes.SET_ORIGINS_OF_INSPIRATION_COLLECTORS:
      return {
        ...state,
        originsOfInspiration: action.payload,
      };
    case CollectorsPageActionTypes.SET_GENDER_COLLECTORS:
      return {
        ...state,
        gender: action.payload,
      };
    case CollectorsPageActionTypes.SET_LOCATION_FILTER_COLLECTORS:
      return {
        ...state,
        location: action.payload,
      };

    case CollectorsPageActionTypes.SET_RADIUS_COLLECTORS:
      return {
        ...state,
        radius: action.payload,
      };
    default:
      return state;
  }
};
